/* eslint no-underscore-dangle: ["error", { "allow": ["__typename"] }] */
import React, { Component } from 'react';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// global variables
// our components
import { Mutation } from 'components/common/Query';
import Commands from './Commands';

export const RESTART_INDEX_MUTATION = gql`
  mutation restartIndex {
    restartIndex {
      ok
    }
  }
`;
export const POPULATE_INDEX_MUTATION = gql`
  mutation populateIndex {
    populateIndex {
      ok
    }
  }
`;
export const RUN_AUTO_PAIDAD_AUDITOR_MUTATION = gql`
  mutation runAutoPaidAdAuditor {
    runAutoPaidAdAuditor {
      ok
    }
  }
`;

export const DELETE_CATEGORIES_CACHE_MUTATION = gql`
  mutation deleteCategoriesCache {
    deleteCategoriesQueryCache {
      ok
    }
  }
`;

/**
 * Mutation to update user
 */
export const INDEX_AD_MUTATION = gql`
  mutation($id: ID) {
    indexAd(input: { id: $id }) {
      errors {
        field
        messages
      }
      clientMutationId
    }
  }
`;

export const DELETE_CACHE_KEY_MUTATION = gql`
  mutation($key: String!) {
    deleteCacheKey(key: $key) {
      ok
    }
  }
`;

export const RESET_PROFILE_METRICS_MUTATION = gql`
  mutation resetProfileMetrics {
    resetProfileMetrics(input: {}) {
      success
    }
  }
`;

class CommandsContainer extends Component {
  constructor(props) {
    super(props);
    this.Compose = adopt({
      mutateReset: this.ResetMutation,
      mutatePopulate: this.PopulateMutation,
      mutateAuditor: this.AuditorMutation,
      mutateDeleteCategoriesCache: this.DeleteCategoriesCacheMutation,
      mutateIndex: this.adIndex,
      mutateDeleteCacheKey: this.deleteCacheKey,
      mutateResetProfileMetrics: this.resetProfileMetrics,
    });
  }

  ResetMutation = ({ render }) => (
    <Mutation mutation={RESTART_INDEX_MUTATION}>
      {handleRestartMutation => render({ handleRestartMutation })}
    </Mutation>
  );

  PopulateMutation = ({ render }) => (
    <Mutation mutation={POPULATE_INDEX_MUTATION}>
      {handlePopulateMutation => render({ handlePopulateMutation })}
    </Mutation>
  );

  AuditorMutation = ({ render }) => (
    <Mutation mutation={RUN_AUTO_PAIDAD_AUDITOR_MUTATION}>
      {handleAuditorMutation => render({ handleAuditorMutation })}
    </Mutation>
  );

  DeleteCategoriesCacheMutation = ({ render }) => (
    <Mutation mutation={DELETE_CATEGORIES_CACHE_MUTATION}>
      {handleDeleteCategoriesCacheMutation =>
        render({ handleDeleteCategoriesCacheMutation })
      }
    </Mutation>
  );

  adIndex = ({ render }) => (
    <Mutation mutation={INDEX_AD_MUTATION}>
      {(handleAdIndex, { loading }) =>
        render({ handleAdIndex, loadingIndex: loading })
      }
    </Mutation>
  );

  deleteCacheKey = ({ render }) => (
    <Mutation mutation={DELETE_CACHE_KEY_MUTATION}>
      {(handleDeleteCacheKey, { loading }) =>
        render({ handleDeleteCacheKey, loadingDeleteCacheKey: loading })
      }
    </Mutation>
  );

  resetProfileMetrics = ({ render }) => (
    <Mutation mutation={RESET_PROFILE_METRICS_MUTATION}>
      {handleResetProfileMetrics => render({ handleResetProfileMetrics })}
    </Mutation>
  );

  /**
   * @description
   * Render PermissionList component.
   * @returns {*} PermissionList component.
   */
  render() {
    return (
      <this.Compose>
        {({
          mutateReset: { handleRestartMutation },
          mutatePopulate: { handlePopulateMutation },
          mutateAuditor: { handleAuditorMutation },
          mutateIndex: { handleAdIndex, loadingIndex },
          mutateDeleteCategoriesCache: { handleDeleteCategoriesCacheMutation },
          mutateDeleteCacheKey: { handleDeleteCacheKey, loadingDeleteCacheKey },
          mutateResetProfileMetrics: { handleResetProfileMetrics },
        }) => (
          <Commands
            restartIndex={handleRestartMutation}
            populateIndex={handlePopulateMutation}
            auditorIndex={handleAuditorMutation}
            adIndex={id => handleAdIndex({ variables: { id } })}
            loadingIndex={loadingIndex}
            deleteCategoriesCache={handleDeleteCategoriesCacheMutation}
            deleteCacheKey={key => handleDeleteCacheKey({ variables: { key } })}
            loadingDeleteCacheKey={loadingDeleteCacheKey}
            resetProfileMetrics={handleResetProfileMetrics}
          />
        )}
      </this.Compose>
    );
  }
}

export default CommandsContainer;
